/* eslint-disable react-hooks/exhaustive-deps */
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import classes from './NavPlaybook.module.css';
import { MergefloColors } from '../../../helper/MergefloColors';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RouteEnums } from '@Helper/Enums';
import { useDispatch } from 'react-redux';
import { postSearchString } from '@Store/feature/listTaskSlice';
import { postSectionList } from '@Store/feature/playBookDetailSlice';
import { DealProjectDTO } from '@Helper/Interfaces';

type Props = {
  playBook: DealProjectDTO;
  openDrawer: boolean;
};

const NavPlaybookItem: FC<Props> = ({ playBook, openDrawer }) => {
  const dispatch = useDispatch();
  const mergefloColors = new MergefloColors();
  const { id, pid } = useParams();
  const [isActive, setIsActive] = useState(false);
  let navigate = useNavigate();
  const location = useLocation();
  const [currentUrl, setcurrentUrl] = useState('');

  useEffect(() => {
    if (
      currentUrl !== '' &&
      !currentUrl.includes(location.pathname) &&
      location.pathname.includes('playbook')
    ) {
      dispatch(postSearchString(''));
      dispatch(postSectionList(undefined));
      setcurrentUrl(location.pathname);
    }
  }, [location]);

  const handleClick = () => {
    navigate(
      RouteEnums.Playbook +
        (id ?? playBook.project?.workspaceId) +
        '/' +
        playBook.id +
        '/2'
    );
  };

  useEffect(() => {
    if (id && pid) {
      setIsActive(
        document.URL.indexOf(
          RouteEnums.Playbook +
            playBook.project?.workspaceId +
            '/' +
            playBook.id +
            '/2'
        ) !== -1
      );
    }
  }, [id, pid]);

  return (
    <div className={isActive ? classes.active : undefined}>
      <ListItemButton
        onClick={handleClick}
        sx={{
          height: 40,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: 2,
            justifyContent: 'center',
          }}
        >
          <div
            className={classes.PlaybookTitle}
            style={{
              background:
                playBook.functionalArea?.color ??
                mergefloColors.getPlaybookColor(playBook.project.name),
            }}
          >
            <div className={classes.PlaybookText}>
              {playBook.project.name[0]}
            </div>
          </div>
        </ListItemIcon>
        <ListItemText
          className={[classes.PlaybookName].join(' ')}
          primary={playBook.project.name}
        />
      </ListItemButton>
    </div>
  );
};

export default NavPlaybookItem;
